function debounce(fn, delay) {
  let timeoutID;
  return function (...args) {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
    timeoutID = setTimeout(() => {
      fn(...args);
    }, delay);
  };
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 100);
    const facetForm = this.querySelector('form');
    if (facetForm) {
      facetForm.addEventListener('input', (event) => {
        FacetFiltersForm.addSkeletonEffect();
        this.debouncedOnSubmit(event);
      });
    }
    this.setupResetButtons();
    this.setupSortBy();
    this.setupPagination();
  }

  static setListeners() {
    window.addEventListener('popstate', (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, false);
    });
  }

  static addSkeletonEffect() {
    const productCards = document.querySelectorAll(
      '#collection-product-grid .product-card',
    );
    productCards.forEach((card) => {
      card.classList.add('hidden');
    });
    document.getElementById('skeleton-grid').classList.remove('hidden');
  }

  static removeSkeletonEffect() {
    document.getElementById('skeleton-grid').classList.add('hidden');
  }

  static renderPage(searchParams, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const productGrid = document.getElementById('product-grid');
    if (!productGrid) {
      return;
    }
    const sectionId = productGrid.dataset.id;
    const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;

    axios
      .get(url)
      .then((response) => {
        const newDocument = new DOMParser().parseFromString(
          response.data,
          'text/html',
        );
        const newProductGridContainer = newDocument.getElementById(
          'collection-product-grid',
        );
        const newProductCount = newDocument.getElementById('ProductCount');

        if (newProductGridContainer) {
          document.getElementById('collection-product-grid').innerHTML =
            newProductGridContainer.innerHTML;
        }

        if (newProductCount) {
          document.getElementById('ProductCount').innerHTML =
            newProductCount.innerHTML;
        }

        FacetFiltersForm.removeSkeletonEffect();

        if (updateURLHash) {
          history.replaceState(
            { searchParams },
            '',
            `${window.location.pathname}?${searchParams}`,
          );
        }
      })
      .catch((error) => {
        console.error('Error fetching the page:', error);
        FacetFiltersForm.removeSkeletonEffect();
      });
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData);
    if (searchParams.has('availability')) {
      const availability = searchParams.get('availability');
      searchParams.delete('availability');
      searchParams.append('filter.v.availability', availability);
    }
    if (searchParams.has('product_type')) {
      const productType = searchParams.getAll('product_type');
      searchParams.delete('product_type');
      productType.forEach((type) => {
        searchParams.append('filter.p.product_type', type);
      });
    }
    const sortByElement = document.getElementById('SortBy');
    if (sortByElement && sortByElement.value) {
      searchParams.append('sort_by', sortByElement.value);
    }
    return searchParams.toString();
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const form = event.target.closest('form');
    if (!form) {
      return;
    }
    const searchParams = this.createSearchParams(form);
    FacetFiltersForm.renderPage(searchParams, false);
  }

  setupResetButtons() {
    const resetButtons = document.querySelectorAll('button[data-target]');
    resetButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        const target = event.target.getAttribute('data-target');
        const form = document.getElementById('FacetSortForm');

        if (!form) {
          console.error('Form not found');
          return;
        }

        if (target === 'availability') {
          const checkboxes = form.querySelectorAll(`input[name="${target}"]`);
          checkboxes.forEach((checkbox) => {
            checkbox.checked = false;
          });
        } else if (target === 'price_range') {
          const minInput = form.querySelector(
            `input[name="filter.v.price.gte"]`,
          );
          const maxInput = form.querySelector(
            `input[name="filter.v.price.lte"]`,
          );
          if (minInput) minInput.value = '';
          if (maxInput) maxInput.value = '';
        } else {
          const checkboxes = form.querySelectorAll(`input[name*="${target}"]`);
          checkboxes.forEach((checkbox) => {
            checkbox.checked = false;
          });
        }

        FacetFiltersForm.addSkeletonEffect();

        const formData = new FormData(form);
        const searchParams = new URLSearchParams(formData).toString();
        FacetFiltersForm.renderPage(searchParams, true);
      });
    });
  }

  setupSortBy() {
    const sortByElement = document.getElementById('SortBy');
    if (sortByElement) {
      sortByElement.addEventListener('change', (event) => {
        FacetFiltersForm.addSkeletonEffect();
        const searchParams = this.createSearchParams(
          this.querySelector('form'),
        );
        FacetFiltersForm.renderPage(searchParams, false);
      });
    }
  }

  setupPagination() {
    document.addEventListener('click', (event) => {
      const paginationLink = event.target.closest('.pagination-link');
      if (paginationLink) {
        event.preventDefault();
        FacetFiltersForm.addSkeletonEffect();
        const url = new URL(paginationLink.href);
        const searchParams = url.searchParams.toString();
        FacetFiltersForm.renderPage(searchParams, true);
      }
    });
  }
}

FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
